<SettingsAddUserModal
    :is_open="is_open"
    :is_saving="is_saving"
    :form_error="form_error"
    :role_options="role_options"
    :is_loading_roles="is_loading_roles"
    @close="close_modal"
    @submit="save_user"
/>
